<template>
  <section class="page-section">
        <div class="form-module">
          <div class="module-body">
            <!-- table -->
            <div class="table-region" style="margin-top: 0" v-loading="tableLoading">
              <!-- 分销收益 -->
              <div class="statistics" style="margin-top: 0">
                <span class="item">可提现：￥{{ statistics.validBalance || 0 }}</span>
                <span class="item">冻结中：￥{{ statistics.frozenBalance || 0 }}</span>
                <span class="item">已提现：￥{{ (statistics.withdrawBalance || 0) }}</span>
              </div>
              <!-- 申请提现 -->
              <el-button type="primary" style="margin-top: 10px" @click="handleWithdrawalDialogShow">申请提现</el-button>
              <!-- 提现记录 -->
              <el-table size="small" :data="tableData" style="margin-top: 10px">
                <el-table-column label="提现申请时间">
                  <template slot-scope="scope">
                    <p>{{ COMMON.formatDate('2', '-', scope.row.createDate) }}</p>
                  </template>
                </el-table-column>
                <el-table-column label="提现金额">
                  <template slot-scope="scope">
                    <p>{{ scope.row.amount }}</p>
                  </template>
                </el-table-column>
                <el-table-column label="提现账户">
                  <template slot-scope="scope">
                    <p>
                      <span>开户行：{{ scope.row.bank }}</span><br>
                      <span>卡号：{{ scope.row.cardId }}</span><br>
                      <span>账户名：{{ scope.row.cardName }}</span>
                    </p>
                  </template>
                </el-table-column>
                <el-table-column label="提现完成时间">
                  <template slot-scope="scope">
                    <p v-if="scope.row.status == 1">{{ COMMON.formatDate('2', '-', scope.row.lastUpdateDate) }}</p>
                  </template>
                </el-table-column>
                <el-table-column label="状态">
                  <template slot-scope="scope">
                    <p v-if="scope.row.status == 0">处理中</p>
                    <p v-if="scope.row.status == 1">提现成功</p>
                    <p v-if="scope.row.status == 2">提现失败</p>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="table-footer" v-if="page.total > 0">
              <div class="selection-operate"></div>
              <div class="pagination-wrap">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                  :page-sizes="[20, 50, 100]" :pager-count="5" :current-page="page.current" :page-size="page.size"
                  layout="total, sizes, prev, pager, next, jumper" :total="page.total">
                </el-pagination>
              </div>
            </div>
          </div>
        </div>
      

    <!-- 申请提现 -->
    <el-dialog title="申请提现" :visible.sync="dialogShow" width="400px">
      <el-form size="small" ref="formDialog" :model="formDialog" label-width="80px" class="dialog-form">
        <el-form-item label="开户行">
          <el-select v-model="formDialog.bankId" placeholder="请选择" style="width: 100%">
            <el-option v-for="(row, rowIndex) in bankOptions" :label="row.name" :value="row.id"
              :key="rowIndex"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="卡号">
          <el-input v-model="formDialog.card" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="账户名">
          <el-input v-model="formDialog.name" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="提现金额">
          <el-input v-model="formDialog.amount" type="number" :min="0" :max="9999999999" placeholder="请输入"
            @blur="handleAmountChange"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" plain @click="dialogShow = false">取 消</el-button>
        <el-button size="small" type="primary" @click="handleWithdrawalSave" :loading="dialogLoading">确 定</el-button>
      </span>
    </el-dialog>
      </section>
</template>

<script>
import {
  COMMON,
  agentIncome,
  agentCompanyDetailWithdrawalList,
  agentWithdrawalsSave,
  distributionBankList
} from '@/common/api';

export default {
  data() {
    return {
      COMMON,

      id: localStorage.getItem('companyId') && localStorage.getItem('companyId') !== 'null' ? localStorage.getItem('companyId') : null,

      pageLoading: false, // 页面loading
      detail: {}, // 详情

      tabName: '1',
      subTabName: '1',

      tableData: [],
      tableLoading: false,
      page: { // 分页参数
        current: 1,
        size: 20,
        total: 0
      },

      statistics: {
        validBalance: 0,
        frozenBalance: 0,
        withdrawBalance: 0
      },

      bankOptions: [],
      dialogShow: false,
      dialogLoading: false,
      formDialog: {
        bankId: '',
        card: '',
        amount: '',
        name: ''
      },

      operatePermission: COMMON.getPermissionStatus(10006) // 用户编辑权限
    }
  },
  methods: {
    /**
     * [getList description] 获取 tab 列表数据
     * @return {[type]} [description]
     */
    getList: function () {
      // 提现记录
      this.getWithdrawalList()
    },
    /**
     * [getAgentIncome description] 分销收益统计
     * @return {[type]} [description]
     */
    getAgentIncome: function () {
      let params = {}
      if (this.id) {
        params.companyId = this.id
      }

      agentIncome(params).then(res => {
        let { code, data, msg } = res;

        if (code == 0) {
          const { validBalance, frozenBalance, withdrawBalance } = data
          Object.assign(this.statistics, {
            validBalance,
            frozenBalance,
            withdrawBalance
          })
        } else {
          this.$message.error(msg);
        }
      }).catch(error => {
        this.$message.error('服务器异常');
      });
    },
    /**
     * [getWithdrawalList description] 提现记录
     * @return {[type]} [description]
     */
    getWithdrawalList: function () {
      this.tableLoading = true;

      let params = {
        current: this.page.current,
        size: this.page.size
      }
      if (this.id) {
        params.companyId = this.id
      }

      agentCompanyDetailWithdrawalList(params).then(res => {
        let { code, data, msg } = res;

        if (code == 0) {
          this.tableData = data.records || [];
          this.tableLoading = false;
          this.page.total = data.total;
          this.$nextTick(() => {
            const scrollContainer = document.querySelector('.app-container');
            if (scrollContainer) {
              scrollContainer.scrollTop = 0;
            }
          });
        } else {
          this.$message.error(msg);
        }
      }).catch(error => {
        this.$message.error('服务器异常');
      });
    },
    /**
     * [handleSizeChange description] 分页每页条数变化
     * @param  {[type]} val [description]
     * @return {[type]}     [description]
     */
    handleSizeChange(val) {
      this.page.current = 1;
      this.page.size = val;

      this.getList();
    },
    /**
     * [handleCurrentChange description] 选择分页第几页
     * @param  {[type]} val [description]
     * @return {[type]}     [description]
     */
    handleCurrentChange(val) {
      this.page.current = val;

      this.getList();
    },
    /**
     * [handleWithdrawalDialogShow description] 申请提现 - 弹窗 - 显示
     * @return {[type]}          [description]
     */
    handleWithdrawalDialogShow() {
      this.dialogLoading = false;
      Object.assign(this.formDialog, {
        bankId: '',
        card: '',
        amount: this.statistics.validBalance || '',
        name: ''
      })
      this.dialogShow = true;
    },
    /**
     * [handleWithdrawalSave description] 申请提现 - 弹窗 - 保存
     * @return {[type]}          [description]
     */
    handleWithdrawalSave: function () {
      if (!this.formDialog.bankId) {
        this.$message.error('请选择开户行');
        return false;
      }
      if (this.formDialog.card == '') {
        this.$message.error('请输入卡号');
        return false;
      }
      if (this.formDialog.amount == '') {
        this.$message.error('请输入提现金额');
        return false;
      }
      if (isNaN(this.formDialog.amount) || this.formDialog.amount <= 0) {
        this.$message.error('提现金额需大于0');
        return false;
      }
      if (this.formDialog.name == '') {
        this.$message.error('请输入账户名');
        return false;
      }

      this.dialogLoading = true;

      let param = {
        'bankId': this.formDialog.bankId,
        'card': this.formDialog.card,
        'amount': this.formDialog.amount,
        'name': this.formDialog.name
      }
      if (this.id) {
        param.companyId = this.id
      }

      agentWithdrawalsSave(param).then(res => {
        this.dialogLoading = false;
        this.dialogShow = false;

        let { code, data, msg } = res;

        if (code == 0) {
          this.$message.success('申请成功');
          this.getList();
        } else {
          this.$message.error(msg);
        }
      }).catch(error => {
        this.$message.error('服务器异常');
        this.dialogLoading = false;
      })
    },
    handleAmountChange() {
      const { amount } = this.formDialog
      const num = Number(amount);
      if (!isNaN(num) && num > 0) {

      } else {
        this.$message.error('请输入大于0的数字');
        Object.assign(this.formDialog, {
          amount: ''
        })
      }
    },
    /**
     * [getBankList description] 银行列表
     * @return {[type]} [description]
     */
    getBankList: function () {
      let params = {}
      distributionBankList(params).then(res => {
        let { code, data, msg } = res;

        if (code == 0) {
          this.bankOptions = data || [];
        } else {
          this.$message.error(msg);
        }
      }).catch(error => {
        this.$message.error('服务器异常');
      });
    },
  },
  mounted: function () {
    this.getList()
    this.getAgentIncome()
    this.getBankList()
  }
}
</script>

<style lang="scss" scoped>
@import '../../../common/styles/base/_mixin-font';
@import "../../../common/styles/base/mixin-common";

.table-region {
  margin-bottom: 50px;
}

.statistics {
  margin-top: -10px;
  padding: 10px;
  background: #EFFAFF;
  border-radius: 4px;
  font-size: 0;

  &.default {
    border: 1px solid #D9D9D9;
    background: transparent;
  }

  .item {
    font-size: 12px;
    color: #222222;
    letter-spacing: 0;
    font-weight: 600;

    &+.item {
      margin-left: 80px;
    }
  }
}

.no-margin-top {
  margin-top: 0;
}

.mr-10 {
  margin-right: 10px;
}

.mr-20 {
  margin-right: 20px;
}

.pt-pb-10 {
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}

.item-tab-body {
  margin: 10px 0;
  font-size: $smallFS;

  div {
    position: relative;
    display: inline-block;
    padding: 10px 30px;
    cursor: pointer;

    &.current {
      color: $themeColor;

      &:after {
        content: '';
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 3px;
        background: $themeColor;
        z-index: 1;
      }
    }
  }
}

.order-list-item {

  &.only-bottom-border {
    border: none;
    border-bottom: 1px solid $separateDefaultColor !important;
  }

  .customTableDropDownListBackgroundColor {
    margin-left: 0 !important;
    margin-right: 0 !important;
    padding: 10px 5px;
    background-color: $customTableDropDownListBackgroundColor;
  }

  .overdue {
    opacity: .5;
    filter: alpha(opacity=50);
  }

  .item-body-body {
    margin: 0 10px;

    &.no-margin {
      margin: 0;
    }

    .item-body-body-header {
      background-color: $colorTitleBg;
    }

    .item-body-body-body {
      padding: 10px 0;
    }
  }
}

.module-body {
  .text {
    font-size: $smallFS;
    color: $textColor;
    line-height: 27px;
  }

  .avatar {
    position: relative;
    float: left;
    width: 150px;
    height: 150px;
    margin-left: 10px;
    /*background: $colorImgBg;*/

    img {
      max-width: 100%;
      max-height: 100%;
      @include position(absolute, 1, 50%, none, none, 50%);
      @include translate(-50%, -50%, 0);
    }
  }

  .info {
    float: left;
    margin-left: 10px;
  }

  .personal-info-box {
    margin-bottom: 40px;

    .personal-info {
      float: left;
      margin-left: 10px;
    }

    .personal-avatar-info {
      float: left;
      margin-left: 40px;

      .personal-avatar {
        position: relative;
        margin-top: 5px;
        width: 200px;
        height: 130px;
        background: $colorImgBg;

        img {
          max-width: 100%;
          max-height: 100%;
          @include position(absolute, 1, 50%, none, none, 50%);
          @include translate(-50%, -50%, 0);
        }
      }
    }

    .personal-first-avatar-info {
      float: left;
      margin-left: 40px;

      .personal-first-avatar {
        position: relative;
        margin-top: 5px;
        width: 200px;
        height: 130px;
        background: $colorImgBg;

        img {
          max-width: 100%;
          max-height: 100%;
          @include position(absolute, 1, 50%, none, none, 50%);
          @include translate(-50%, -50%, 0);
        }
      }
    }
  }
}

.dialog-photo-past {
  position: relative;
  margin: 0 auto;
  padding: 10px 0;

  p {
    margin-bottom: 20px;
    text-align: center;
  }

  .pic-list {
    position: relative;
    margin: 0 auto;
    width: 420px;
    height: 130px;

    .pic-item {
      position: relative;
      width: 110px;
      height: 130px;
      margin: 0 15px;
      background: $colorImgBg;

      img {
        @include position(absolute, 3, 50%, none, none, 50%);
        max-width: 100%;
        max-height: 100%;
        @include translate(-50%, -50%, 0);
      }
    }
  }

  .left-icon,
  .right-icon {
    position: absolute;
    z-index: 5;
    top: 50%;
    margin-top: -20px;
    font-size: 34px;
    color: $swiperArrowColor;
    cursor: pointer;

    &:hover {
      color: $darkButtonBackgroundHoverColor;
    }

    &[disabled="disabled"] {
      opacity: .3;
      cursor: not-allowed;
    }
  }

  .left-icon {
    left: 0;
  }

  .right-icon {
    right: 0;
  }
}
</style>
